'use client';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import GlobalLoader from '../GlobalLoader';
import VillageEnquiryForm from '../EnquiryForm/VillageEnquiryForm';

import { getTranslatedSchema } from '../EnquiryForm/villageSchema';
import { IEnquiryFormDictionary } from '@/dictionaries/components/enquiryForm/types';
import { ICountriesDictionary } from '@/dictionaries/utils/countries/types';
import { IModalsDictionary } from '@/dictionaries/components/modals/types';
import { IDatePickerDictonary } from '@/dictionaries/components/datePicker/types';
import useDatePickerContext from '@/hooks/useDatePickerContext';
import { VscClose } from 'react-icons/vsc';
import { cn } from '@/lib/utils';
import { Village } from '@/services/types';

type Props = {
  village: Village;
  formDict: IEnquiryFormDictionary;
  lang: string;
  countriesDict: ICountriesDictionary;
  modalsDict: IModalsDictionary;
  datePickerDict: IDatePickerDictonary;
  handleModalState: (open: boolean) => void;
};

export default function NotifyVillageAvailabilityModal(props: Props) {
  const [willUnmount, setWillUnmount] = useState(false);

  const { enquiryModalIsOpen, setEnquiryModalIsOpen, setSuccessModalIsOpen } =
    useDatePickerContext();

  const { formDict } = props;

  const schema = getTranslatedSchema(props.formDict.errors);

  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: {},
  });

  const handleCloseModal = () => {
    setWillUnmount(true);
    setTimeout(() => {
      setEnquiryModalIsOpen(false);
      setWillUnmount(false);
    }, 200);
  };

  return (
    <>
      {enquiryModalIsOpen && (
        <div
          className={cn(
            'fixed top-0 left-0 md:top-1/2 md:left-1/2  md:-translate-x-1/2 md:-translate-y-1/2 flex justify-start sm:justify-center items-start sm:items-center md:w-[calc(100%+5rem)] desktop:w-full h-fit md:h-full md:mt-[5vh] desktop:mt-0 z-[2147483649]',
            {
              'animate-mobile-close-modal md:animate-close-modal': willUnmount,
            },
            {
              'animate-mobile-open-modal md:animate-open-modal': !willUnmount,
            },
          )}>
          <div className="relative flex flex-col justify-start items-center w-full h-fit md:min-h-full md:max-h-fit px-[60px] pt-[50px] bg-white gap-4">
            <GlobalLoader
              className="absolute z-[2147483650]"
              isLoading={form.formState.isSubmitting}
            />
            <button
              className="absolute top-[10px] desktop:-top-[10px] right-[10px] desktop:-right-[10px] flex justify-center items-center w-10 h-10 bg-white shadow-default rounded-full z-10"
              onClick={handleCloseModal}>
              <VscClose className="w-7 h-7 text-gray-500" />
            </button>
            <div className="flex flex-col">
              <h2 className="mb-2 text-4xl font-semibold">
                {formDict.datePickerEnquiry.title}
              </h2>
              <p className="mb-4">{formDict.datePickerEnquiry.description}</p>
              <VillageEnquiryForm
                atModal
                form={form}
                setSuccessModalIsOpen={setSuccessModalIsOpen}
                onSuccess={() => {
                  setEnquiryModalIsOpen(false);
                  props.handleModalState(false);
                }}
                {...props}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
